import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { UsersRoutingModule } from './users-routing.module';
import { LayoutComponent } from './layout.component';
import { ListComponent } from './list.component';
import { AddEditComponent } from './add-edit.component';
import { AddDealerComponent } from './add-dealer.component';
import { DealerListComponent } from './dealer-list.component';
import { AddEditPlanDetailsComponent } from './add-edit-plan-details/add-edit-plan-details.component';
import { AddPaymentComponent } from './add-payment/add-payment.component';
import { ViewDealerComponent } from './view-dealer/view-dealer.component';
import { AddPayoutComponent } from './add-payout/add-payout.component';
import { DealerPaymentComponent } from './dealer-payment/dealer-payment.component';
import { AgGridModule } from 'ag-grid-angular';
import { PackagePaymentComponent } from './package-payment/package-payment.component';
import { NoScrollNumberDirective } from '../_helpers/no-scroll-number.directive';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        UsersRoutingModule,
        AgGridModule,
        NoScrollNumberDirective
    ],
    declarations: [
        LayoutComponent,
        ListComponent,
        AddEditComponent,
        AddDealerComponent,
        DealerListComponent,
        AddEditPlanDetailsComponent,
        AddPaymentComponent,
        ViewDealerComponent,
        AddPayoutComponent,
        DealerPaymentComponent,
        PackagePaymentComponent
        // DealerPaymentGatewayComponent
    ],
    // exports:[DealerPaymentGatewayComponent]
})
export class UsersModule { }